import type { RosterRuleKind, StaffScheduleStatus } from '../types/Rostering';

export const STAFF_SCHEDULE_STATUSES: StaffScheduleStatus[] = [
  'working',
  'management',
  'studyLeave',
  'holiday',
  'sickLeave',
  'otherLocation',
  'workingFromHome',
];

const STATUS_ALIASES: Record<string, StaffScheduleStatus> = {
  working: 'working',
  management: 'management',
  studyleave: 'studyLeave',
  holiday: 'holiday',
  sickleave: 'sickLeave',
  otherlocation: 'otherLocation',
  workingfromhome: 'workingFromHome',
};

export const normalizeStaffScheduleStatus = (
  value: unknown,
  fallbackType?: RosterRuleKind,
): StaffScheduleStatus => {
  const normalized = String(value ?? '').trim();
  if (!normalized) {
    return fallbackType === 'staffTimeOff' ? 'holiday' : 'working';
  }

  const alias = STATUS_ALIASES[normalized.toLowerCase().replace(/[\s_-]/g, '')];
  if (alias) {
    return alias;
  }

  if (STAFF_SCHEDULE_STATUSES.includes(normalized as StaffScheduleStatus)) {
    return normalized as StaffScheduleStatus;
  }

  return fallbackType === 'staffTimeOff' ? 'holiday' : 'working';
};

export const scheduleStatusToRuleType = (status: StaffScheduleStatus): RosterRuleKind => (
  status === 'working' || status === 'management' ? 'staffShift' : 'staffTimeOff'
);

export const defaultScheduleStatusForTab = (tab: 'schedule' | 'onCall'): StaffScheduleStatus => (
  tab === 'schedule' ? 'working' : 'holiday'
);

export const isBookableScheduleStatus = (status: StaffScheduleStatus): boolean => (
  status === 'working' || status === 'management'
);
